export default "__VITE_ASSET__1dde53fc__"